import importerStore from '@shared/importer/importer-store';
import { PaymentOptionService } from '@modules/payment-option/payment-option-service';
import paymentOptionImporterFields from '@modules/payment-option/payment-option-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  PaymentOptionService.import,
  paymentOptionImporterFields,
  i18n('entities.paymentOption.importer.fileName'),
  i18n('entities.paymentOption.importer.hint'),
);
